export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            手机吃瓜
          </h2>
          <p className="mt-2 text-sm text-foreground-500">随时随地打开51吃瓜黑料入口，吃瓜不设限</p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-8 bg-background-50 border border-background-200/60 rounded-lg p-8">
            <div className="flex-1 text-center lg:text-left">
              <span className="inline-block text-xs font-medium text-accent-500 bg-accent-100 px-3 py-1 rounded-full mb-4 whitespace-nowrap">
                无需下载
              </span>
              <h3 className="text-xl font-heading font-bold text-foreground-950 mb-4">
                浏览器打开即用
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-6">
                51吃瓜黑料网无需下载APP，直接在手机浏览器中输入51吃瓜黑料网址即可访问。
                页面已针对移动端全面优化，加载快、省流量，浏览体验与原生应用无异。
              </p>
              <div className="flex flex-col sm:flex-row items-center gap-3">
                <div className="flex items-center gap-2 px-4 py-2.5 bg-background-100 border border-background-200/60 rounded-lg">
                  <i className="ri-links-line text-primary-500"></i>
                  <span className="text-sm text-foreground-700 font-medium">51cg.cn</span>
                </div>
                <button className="w-full sm:w-auto px-6 py-2.5 bg-primary-500 text-background-50 font-medium text-sm rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                  立即访问
                </button>
              </div>
            </div>

            <div className="flex-shrink-0">
              <div className="w-40 h-40 md:w-48 md:h-48 flex items-center justify-center bg-primary-100 rounded-2xl">
                <i className="ri-smartphone-line text-6xl text-primary-500"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}